export default "__VITE_ASSET__opGobLYh__"